const CommonPagination = (props) => {
    const { pageList, currentPage, setCurrentPage, itemsPerPage, hasNextPage, loading, totalCount } = props;

    // Server-driven mode with a known total count: caller fetches one page
    // (Skip/Take) at a time but the API also returns how many rows exist in
    // total, so we can render the same numbered pagination as the client-side
    // mode below without holding the full list in memory.
    const hasKnownTotal = typeof totalCount === "number";

    // Server-driven mode, no total count available: caller fetches one page
    // at a time and only knows whether a full page came back (hasNextPage).
    // setCurrentPage here is expected to be the page-fetching function itself.
    if (!pageList && !hasKnownTotal) {
        return (
            <div className="d-flex gap-2 flex-column flex-lg-row justify-content-between align-items-center mt-2">
                <div className="text-muted">
                    <span>Page {currentPage}</span>
                </div>

                <nav>
                    <ul className="pagination mb-0">
                        <li className="page-item">
                            <button
                                style={{
                                    color: 'green',
                                    cursor: (currentPage === 1 || loading) ? 'not-allowed' : 'pointer',
                                    opacity: (currentPage === 1 || loading) ? 0.5 : 1
                                }}
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage === 1 || loading}
                            >
                                Previous
                            </button>
                        </li>
                        <li className="page-item">
                            <button
                                style={{
                                    color: 'green',
                                    cursor: (!hasNextPage || loading) ? 'not-allowed' : 'pointer',
                                    opacity: (!hasNextPage || loading) ? 0.5 : 1
                                }}
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={!hasNextPage || loading}
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }

    // Client-side mode (full list in memory) or server-side mode with a known
    // total count — either way we now know how many total items/pages there are.
    const totalItems = hasKnownTotal ? totalCount : pageList.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Calculate showing range
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <>
            <div className="d-flex gap-2 flex-column flex-lg-row justify-content-between align-items-center mt-2">
                {/* Left side - Showing info */}
                <div className="text-muted">
                    <span>Showing {startItem} to {endItem} of {totalItems} entries</span>
                </div>

                {/* Right side - Pagination buttons */}
                <nav>
                    <ul className="pagination mb-0">
                        <li className="page-item">
                            <button
                                style={{
                                    color: 'green',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                    opacity: currentPage === 1 ? 0.5 : 1
                                }}
                                className="page-link"
                                onClick={() => setCurrentPage(1)}
                                disabled={currentPage === 1}
                            >
                                First
                            </button>
                        </li>

                        {(() => {
                            const maxPagesToShow = 5;
                            let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
                            let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

                            if (endPage - startPage + 1 < maxPagesToShow) {
                                startPage = Math.max(1, endPage - maxPagesToShow + 1);
                            }

                            return [...Array(endPage - startPage + 1)].map((_, index) => (
                                <li key={index} style={{ color: 'green' }} className="page-item">
                                    <button
                                        style={{
                                            color: 'green',
                                            border: currentPage === startPage + index ? '2px solid green' : '2px solid #ccc',
                                            backgroundColor: currentPage === startPage + index ? '#e6ffe6' : 'transparent',
                                            borderRadius: '0',
                                            padding: '5px 10px',
                                            cursor: 'pointer',
                                            zIndex: currentPage === startPage + index ? '2' : '1',
                                            position: 'relative',
                                        }}
                                        className="page-link"
                                        onClick={() => setCurrentPage(startPage + index)}
                                    >
                                        {startPage + index}
                                    </button>
                                </li>
                            ));
                        })()}

                        <li className="page-item">
                            <button
                                className="page-link"
                                onClick={() => setCurrentPage(totalPages)}
                                style={{
                                    color: 'green',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                    opacity: currentPage === totalPages ? 0.5 : 1
                                }}
                                disabled={currentPage === totalPages}
                            >
                                Last
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    )
}

export default CommonPagination;
